import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MDBox from "components/MDBox";
import breakpoints from "assets/theme/base/breakpoints";
import crudsService from "services/cruds-service";

function LangSwitcher({ stickyNavbar, setSelectedLang, setOldSelectedLang }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState();
  const [lang, setLang] = useState([]);

  // getAllData

  const getLanguages = async () => {
    const response = await crudsService.getAllData("items/languages");
    setLang(response.data);
    setSelectedLang(response.data[0]);
    setOldSelectedLang(response.data[0]);
    setTabValue(0);
  };

  useEffect(() => {
    lang.length === 0 && getLanguages();
  }, []);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => {
    setSelectedLang(lang[newValue]);
    setOldSelectedLang(lang[tabValue]);
    setTabValue(newValue);
  };

  return (
    <MDBox>
      <Grid container>
        <Grid item xs={12} sm={8} lg={4}>
          <AppBar position="static">
            <Tabs
              orientation={tabsOrientation}
              value={tabValue}
              onChange={handleSetTabValue}
            >
              {lang.map((l) => (
                <Tab label={l.name} key={l.code} />
              ))}
            </Tabs>
          </AppBar>
        </Grid>
      </Grid>
    </MDBox>
  );
}

// Setting default values for the props of LangSwitcher
LangSwitcher.defaultProps = {
  stickyNavbar: false,
};

// Typechecking props for LangSwitcher
LangSwitcher.propTypes = {
  stickyNavbar: PropTypes.bool,
};

export default LangSwitcher;
